import { ActionTree, ActionContext } from 'vuex';
import { State } from '@/stores/customers/state';
import { CustomerApi } from '@/api/customer-api';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';
import router from '@/router';

const api = new CustomerApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>) => {
        try {
            const result = await api.fetchAsync();
            if (result) {
                context.commit('setCustomers', result.customers);
            }
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
    public fetchUsersAsync = async (context: ActionContext<State, any>, customerId: string) => {
        try {
            const result = await api.fetchUsersForCustomerAsync(customerId);
            if (result) {
                context.commit('setContactNames', result.map((u) => u.email));
            }
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
}
